<template>
  <div>
    <div class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center pb-50"
      >
        <h4 class="card-title">User Locations</h4>
      </div>
      <div class="card-content">
        <div class="card-body p-0 pb-1">
          <ul class="list-group list-group-flush">
            <span v-for="(location, index) of locations" :key="index">
              <li
                class="list-group-item border-0 d-flex align-items-center justify-content-between"
                v-for="(count, city) in location"
                :key="city"
              >
                <div class="list-left d-flex">
                  <div class="list-content">
                    <span class="list-title capitalize">{{ city }}</span>
                  </div>
                </div>
                <span class="badge badge-secondary">{{ count }}</span>
              </li>
            </span>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["locations"],
};
</script>

